import React from "react";
import BreadCrumbs from "@components/breadcrumbs/index1";

const Error = () => {
  return (
    <div>
    <BreadCrumbs breadCrumbTitle="Error" />
      {/* error wrapper start */}
      <div className="error_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <div className="col-md-12 text-center">
              <img
                src="images/error.png"
                alt="img"
                className="img-responsive"
              />
              <div className="error_page_cntnt ms_cover">
                <h3>Sorry, This Page Isn't available :(</h3>
                <p>
                  This is Photoshop's version of Lorem Ipsum. Proin gravida nibh
                  vel velit auctor aliquet. A Aenean sollicitudin, lorem quis
                  bibend Aenean sollicitudin, lorem .
                </p>
                <div className="lang_apply_btn home_btn ms_cover">
                  <ul>
                    <li>
                      <a href="#">home page</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
